// import eight from '../assets/svg/projects/eight.svg'
// import five from '../assets/svg/projects/five.svg'
// import four from '../assets/svg/projects/four.svg'
// import one from '../assets/svg/projects/one.svg'
// import seven from '../assets/svg/projects/seven.svg'
// import six from '../assets/svg/projects/six.svg'
// import three from '../assets/svg/projects/three.svg'
// import two from '../assets/svg/projects/two.svg'
import fifteen from '../assets/svg/projects/fifteen.svg'
import eleven from '../assets/svg/projects/eleven.svg'
import sixteen from '../assets/svg/projects/sixteen.svg'
import ten from '../assets/svg/projects/ten.svg'
import JASS4 from '../assets/svg/projects/JASS4.svg'


export const projectsData = [
    {
        id: 5,
        projectName: 'JASS MAX1 Lubricant',
        projectDesc: 'A Simple E-commerce application, Customer can be manage them and make payment.',
        tags: ['React, Tailwind CSS and Firebase'],
        code: 'https://github.com/cryptomehedi/jass4',
        demo: 'https://jass-max1.web.app',
        image: JASS4
    },
    {
        id: 1,
        projectName: 'Manufacture parts',
        projectDesc: 'This is a manufacturing website where you can get different types of Computer parts with a fully responsive website.',
        tags: ['React, Tailwind CSS, Node Js, Express js, MongoDB, and Firebase'],
        code: 'https://github.com/cryptomehedi/manufacture-parts',
        demo: 'https://manufacture-parts.web.app',
        image: eleven
    },
    {
        id: 2,
        projectName: 'Doctors Portal',
        projectDesc: 'This project is a Doctors appointments, Customer can be manage them and make payment.',
        tags: ['React, Tailwind CSS, Node Js, Express js, MongoDB, and Firebase'],
        code: 'https://github.com/cryptomehedi/doctors-portal-client-side',
        demo: 'https://doctors-portal-e05ca.web.app',
        image: fifteen
    },
    {
        id: 3,
        projectName: 'Warehouse Management',
        projectDesc: 'This project about Warehouse Management.',
        tags: ['React, Tailwind CSS, Node Js, Express js, MongoDB, and Firebase'],
        code: 'https://github.com/cryptomehedi/warehouse-client',
        demo: 'https://warehouse-61589.web.app',
        image: sixteen
    },
    {
        id: 4,
        projectName: 'Oxford Dental',
        projectDesc: 'This project A Doctor Website.',
        tags: ['React, Tailwind CSS and Firebase'],
        code: 'https://github.com/cryptomehedi/oxford-dental',
        demo: 'https://oxford-dental-f3612.web.app',
        image: ten
    },
    
    // {
    //     id: 6,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: one
    // },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: two
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: three
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/